export enum DashboardType {
    PUBLIC = 'public',
    INTERNAL = 'internal',
}
